import { render, staticRenderFns } from "./VipCashier.vue?vue&type=template&id=3defe8c9&scoped=true&"
import script from "./VipCashier.vue?vue&type=script&lang=js&"
export * from "./VipCashier.vue?vue&type=script&lang=js&"
import style0 from "./VipCashier.vue?vue&type=style&index=0&id=3defe8c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defe8c9",
  null
  
)

export default component.exports